/* Program Name: search.js
 **  Description: Logic to search with a searchTerm on an XGrid *MUI*
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-03-17  STT  Initial program
 *********************************************************************************/

/** Search Function ***********************************************************/
/** searchTerm > String = the String of character that we are searching on    */
/** data       > Array[Obj] = the array of Object we are searching in         */
/** columns    > Array[Obj] = the array of columns that we will search        */
/**                           for matches in                                  */
/******************************************************************************/

export function search(searchTerm, data, cols) {
  var keys =
    cols instanceof Array
      ? cols.map((col) => {
          return col.field
        })
      : []

  return data.filter((item) => {
    for (var i = 0; i < keys.length; i++) {
      if (
        String(item[keys[i]]).toUpperCase().includes(searchTerm.toUpperCase())
      ) {
        return item
      }
    }
    return null
  })
}
